import monetizationConfig, { FREE_SEAT, CREATOR_SEAT, STARTER_SEAT, GROWTH_SEAT, ENTERPRISE_SEAT } from '@/config/monetization'; // Get the view limit for the team's subscription type

export function getTeamViewLimit(team) {
  const subscriptionConfig = monetizationConfig.seats.find(seat => seat.nickname === (team === null || team === void 0 ? void 0 : team.subscriptionType));
  return (subscriptionConfig === null || subscriptionConfig === void 0 ? void 0 : subscriptionConfig.viewLimit) || 0;
} // Get the chart limit for the team's subscription type

export function getTeamChartLimit(team) {
  const subscriptionConfig = monetizationConfig.seats.find(seat => seat.nickname === (team === null || team === void 0 ? void 0 : team.subscriptionType));
  return (subscriptionConfig === null || subscriptionConfig === void 0 ? void 0 : subscriptionConfig.chartLimit) ?? FREE_SEAT.chartLimit;
} // Check if the widget editor is accessible for the team's subscription type

export function isWidgetEditorAccessible(team) {
  if (!(team !== null && team !== void 0 && team.subscriptionType) || !(team !== null && team !== void 0 && team.subscriptionActive)) return false;
  return [STARTER_SEAT.nickname, CREATOR_SEAT.nickname, GROWTH_SEAT.nickname, ENTERPRISE_SEAT.nickname].includes(getPlanNickname(team));
} // Lookup the nickname for the teams'
// current subscription, defaulting to free

export function getPlanNickname(team) {
  return team.subscriptionType || FREE_SEAT.nickname;
}